import EditPayRateForm from './EditPayRateForm';
export default EditPayRateForm;
